import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown, MessageCircle } from "lucide-react";
import { FAQS, openWhatsApp } from "@/data/content";

const FAQ = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-slate-50 py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-4">DÚVIDAS</p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0f1733] tracking-tight">Perguntas Frequentes</h2>
          <p className="text-slate-500 text-lg mt-5">Tire suas dúvidas sobre nossos produtos e serviços</p>
        </div>

        <div className="space-y-4">
          {FAQS.map((f, i) => {
            const open = active === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl border border-slate-100 overflow-hidden"
              >
                <button
                  onClick={() => setActive(open ? -1 : i)}
                  className="w-full flex items-center justify-between text-left px-6 py-5 gap-4"
                >
                  <span className="font-bold text-[#0f1733] text-lg">{f.q}</span>
                  <ChevronDown
                    className={`w-5 h-5 text-[#1d3fd9] shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
                  />
                </button>
                <motion.div
                  initial={false}
                  animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <p className="px-6 pb-5 text-slate-500 leading-relaxed">{f.a}</p>
                </motion.div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-500 mb-4">Ainda com dúvidas?</p>
          <button
            data-testid="faq-whatsapp-btn"
            onClick={() => openWhatsApp("Olá! Tenho uma dúvida e gostaria de mais informações.")}
            className="inline-flex items-center gap-2 bg-[#a3e635] hover:bg-[#92d420] text-[#0f1733] font-bold px-8 py-4 rounded-2xl shadow-lg shadow-[#a3e635]/30 transition-all hover:-translate-y-0.5"
          >
            <MessageCircle className="w-5 h-5" /> Fale conosco agora
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
